<mat-card>
  <h2 translate>whitelist.title</h2>
  <mat-card-content>
    <p translate>whitelist.subtitle</p>
    <mat-grid-list cols="16" rowHeight="90px">
      <form [formGroup]="entityForm">
        <mat-grid-tile colspan="7">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="entity"
            [id]="'expirationDayUptakeData'"
            [dataInput]="entityList"
            [placeholder]="'whitelist.entity'"
            [isRequired]="true"
            [showErrors]="entityForm?.controls?.entity?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>
      </form>
    </mat-grid-list>
    <div *ngIf="showChainPrescriptors">
      <div class="table__wrapper">
        <table aria-label="white-list" mat-table [dataSource]="dataSource" *ngIf="hasAnyOperation()">
          <ng-container matColumnDef="icons">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="mat-cell--center mat-cell--width">
              <button id="deleteBtnId" mat-button (click)="onClickDelete(element.entityId, element.userId)">
                <mat-icon class="icon-ic_delete_forever"></mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="prescriptors">
            <th mat-header-cell *matHeaderCellDef translate>whitelist.table.header</th>
            <td mat-cell *matCellDef="let element">
              {{
                element.entityId + ' - ' + element.userId + (element.businessName ? ' - ' + element.businessName : '')
              }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <ng-template #showNoOperations>
        <div fxLayout="column" fxLayoutAlign="center center">
          <mat-label class="panel-request__label-no-operation">No existe ningún prescriptor</mat-label>
        </div>
      </ng-template>
    </div>

    <h3 class="whitelist__subtitle"><b translate>whitelist.label.selectUser</b></h3>
    <button
      id="searchBtnId"
      mat-stroked-button
      color="accent"
      (click)="onClickSearch()"
      [disabled]="isDisabledSearchButton"
    >
      <mat-icon class="icon-ic_search"></mat-icon>
      <span *ngIf="!userSelected; else labelChange">{{ 'whitelistDialog.btnSearch' | translate | uppercase }}</span>
      <ng-template #labelChange>{{ 'whitelist.btnChangeSelection' | translate | uppercase }}</ng-template>
    </button>
    <div class="whitelist__result" *ngIf="userSelected">
      <div class="whitelist__result-row">
        <mat-label class="whitelist__result-row--bold" translate>whitelist.label.user</mat-label>
        <mat-label>{{ userSelected.userId }}</mat-label>
      </div>
      <div class="whitelist__result-row">
        <mat-label class="whitelist__result-row--bold" translate>whitelist.label.commercial</mat-label>
        <mat-label>{{ userSelected.businessName }}</mat-label>
      </div>
      <div class="whitelist__result-row">
        <mat-label class="whitelist__result-row--bold" translate>whitelist.label.host</mat-label>
        <mat-label>{{ userSelected.nif }}</mat-label>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<div class="whitelist__footer">
  <button
    id="createSolutionBtnId"
    mat-stroked-button
    color="accent"
    (click)="onClickCreateSolution()"
    [disabled]="isDisabledSolutionButton"
  >
    <span *ngIf="isUserSelectedInTable(); else labelChangeAssociation">{{
      'whitelist.btnSolution' | translate | uppercase
    }}</span>
    <ng-template #labelChangeAssociation>{{ 'whitelist.btnNewAssociation' | translate | uppercase }}</ng-template>
  </button>
</div>
